import { CheckIcon } from "@heroicons/react/outline";

interface ChecklistFeatureSectionProps {
  features: string[];
  headline: string;
  superheadline: string;
  description: string;
}

const ChecklistFeatureSection: React.FC<ChecklistFeatureSectionProps> = ({
  features,
  headline,
  superheadline,
  description,
}) => {
  return (
    <div className="">
      <div className="max-w-7xl mx-auto pb-16 px-4 sm:pb-24 sm:px-6 lg:px-8">
        <div className="border-t border-gray-200 pt-16 xl:grid xl:grid-cols-3 xl:gap-x-8">
          <div>
            <h2 className="text-base font-semibold text-blue-600 tracking-wide uppercase">
              {superheadline}
            </h2>
            <p className="mt-2 text-3xl font-extrabold text-gray-900">
              {headline}
            </p>
            <p className="mt-4 text-lg text-gray-500">{description}</p>
          </div>
          <div className="mt-4 sm:mt-8 md:mt-10 md:grid md:grid-cols-2 md:gap-x-8 xl:mt-0 xl:col-span-2">
            <ul role="list" className="divide-y divide-gray-200">
              {features.slice(0, 5).map((feature, featureIdx) =>
                featureIdx === 0 ? (
                  <li key={feature} className="py-4 flex md:py-0 md:pb-4">
                    <CheckIcon
                      className="flex-shrink-0 h-6 w-6 text-green-500"
                      aria-hidden="true"
                    />
                    <span className="ml-3 text-base text-gray-500">
                      {feature}
                    </span>
                  </li>
                ) : (
                  <li key={feature} className="py-4 flex">
                    <CheckIcon
                      className="flex-shrink-0 h-6 w-6 text-green-500"
                      aria-hidden="true"
                    />
                    <span className="ml-3 text-base text-gray-500">
                      {feature}
                    </span>
                  </li>
                )
              )}
            </ul>
            <ul
              role="list"
              className="border-t border-gray-200 divide-y divide-gray-200 md:border-t-0"
            >
              {features.slice(5).map((feature, featureIdx) =>
                featureIdx === 0 ? (
                  <li
                    key={feature}
                    className="py-4 flex md:border-t-0 md:py-0 md:pb-4"
                  >
                    <CheckIcon
                      className="flex-shrink-0 h-6 w-6 text-green-500"
                      aria-hidden="true"
                    />
                    <span className="ml-3 text-base text-gray-500">
                      {feature}
                    </span>
                  </li>
                ) : (
                  <li key={feature} className="py-4 flex">
                    <CheckIcon
                      className="flex-shrink-0 h-6 w-6 text-green-500"
                      aria-hidden="true"
                    />
                    <span className="ml-3 text-base text-gray-500">
                      {feature}
                    </span>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChecklistFeatureSection;
